import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Bannieres.module.css";
import { bannerService } from "../../services/api";
import videoBg from "../../assets/videos/video2.mp4"; // Fallback vidéo

const Bannieres = () => {
  const [banner, setBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadBanner = async () => {
      try {
        setIsLoading(true);
        const response = await bannerService.getActiveBanners('home', 1);

        if (response.success && response.data && response.data.length > 0) {
          setBanner(response.data[0]);
        }
      } catch (error) {
        console.error('Erreur lors du chargement de la bannière:', error);
        // En cas d'erreur, on garde le fallback
      } finally {
        setIsLoading(false);
      }
    };

    loadBanner();
  }, []);

  const handleClick = () => {
    if (banner?.link_url) {
      if (banner.link_url.startsWith('/')) {
        navigate(banner.link_url);
      } else {
        window.location.href = banner.link_url;
      }
    } else {
      // Scroll vers la section produits par défaut
      const productsSection = document.getElementById('products-section');
      if (productsSection) {
        productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  // Utiliser la bannière dynamique si disponible, sinon fallback
  const displayBanner = banner || {
    title: 'Manger bien sur notre plateforme',
    description: 'Découvrez nos services et produits',
    video_url: videoBg,
    button_text: 'Explorer'
  };

  if (isLoading) {
    return (
      <section className={styles.banner}>
        <div className={styles.loading}>Chargement...</div>
      </section>
    );
  }

  return (
    <section className={styles.banner}>
      {displayBanner.video_url ? (
        <video
          className={styles.bannerVideo}
          src={displayBanner.video_url}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : displayBanner.image_url ? (
        <div
          className={styles.bannerImage}
          style={{ backgroundImage: `url(${displayBanner.image_url})` }}
        />
      ) : (
        <video
          className={styles.bannerVideo}
          src={videoBg}
          autoPlay
          loop
          muted
          playsInline
        />
      )}
      <div className={styles.bannerContent}>
        <h1>{displayBanner.title}</h1>
        {displayBanner.description && <p>{displayBanner.description}</p>}
        <button onClick={handleClick} className={styles.btn}>
          {displayBanner.button_text || 'Explorer'}
        </button>
      </div>
    </section>
  );
};

export default Bannieres;
